<template>
    <!-- 分页 -->
    <el-col :xs="24" :sm="24" :md="24" :lg="24" class="page" slot="pagination" style="padding-top:10px;">
        <el-pagination 
            style="float:right" 
            background
            class="page_bottom" 
            @size-change="handleSizeChg"
            @current-change="handleCurrentChg"
            :current-page="pageNum"
            :page-size='pageSize'
            :pager-count="pagerCount"
            :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize">
        </el-pagination>
    </el-col>
</template>   
<script>
  export default {
    name:'pagination',
    props:{
        pageNum:{
            type:Number
        },
        pageSize:{
            type:Number
        },
        totalSize:{
            type:Number
        },
        pagerCount:{
            type:Number,
            default:7
        },
        pageSizes:{
            type:Array,
            default: function () {
                return [10, 20, 50, 100]
            }
        }
    },
    data () {
        return{
            value:''
        }
    },
    methods:{
        handleSizeChg(size){
            this.$emit('handleSizeChange',size);
        },
        handleCurrentChg(pageNum){
            this.$emit('handleCurrentChange',pageNum);
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/publicComponents/pagination.vue